import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import VehicleTypeSelect from "./VehicleTypeSelect";

const mapStateToProps = (state) => ({
  enums: state.enums,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleTypeSelect);
